import styled from "styled-components";
import { createShouldForwardPropBlockList, deepMerge } from "../utils/helper";
import { type InlineMessageProps } from "./inline-message";
import { getBackgroundColor, getColor } from "./inline-message.styles.utils";

type WrapperProps = Pick<InlineMessageProps, "align">;
type IconProps = Pick<InlineMessageProps, "color" | "type" | "align">;
type ButtonsProps = Pick<InlineMessageProps, "align">;

export const Wrapper = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["align"]),
})<WrapperProps>(({ align, theme }) => ({
    display: "grid",
    rowGap: theme.spacing[4],
    gridTemplateColumns: theme.gridTemplateColumns[1],
    padding: theme.spacing[6],
    maxWidth: "450px",
    margin: "0 auto",
    ...(align === "center" && {
        textAlign: "center",
    }),
    ...(align === "right" && {
        textAlign: "right",
    }),
}));

export const Icon = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["type", "color", "align"]),
})<IconProps>(({ type, color, align, theme }) => ({
    width: theme.spacing[10],
    height: theme.spacing[10],
    borderRadius: theme.borderRadius.DEFAULT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...(align === "center" && {
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: theme.borderRadius.full,
    }),
    ...(align === "right" && {
        marginLeft: "auto",
    }),
    ...deepMerge(getBackgroundColor(type, color, theme)),
    "& svg": {
        width: theme.spacing[4],
        height: theme.spacing[4],
        ...deepMerge(getColor(type, color, theme)),
    },
}));

export const Body = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: theme.gridTemplateColumns[1],
    rowGap: theme.spacing[1],
}));

export const Headline = styled("div")(({ theme }) => ({
    fontSize: theme.fontSize.lg,
    fontWeight: theme.fontWeight.semibold,
    lineHeight: theme.lineHeight.tight,
}));

export const Text = styled("div")(({ theme }) => ({
    fontSize: theme.fontSize.xs,
    color: theme.colors.gray[600],
}));

export const Buttons = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["align"]),
})<ButtonsProps>(({ align, theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: `${theme.spacing[4]} ${theme.spacing[2]}`,
    flexWrap: "wrap",
    ...(align === "center" && {
        justifyContent: "center",
    }),
    ...(align === "right" && {
        justifyContent: "end",
    }),
}));
